'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

/* Stores */

var _storesModuleInspector = require('stores/module-inspector');

var _storesModuleInspector2 = _interopRequireDefault(_storesModuleInspector);

/* Components */

var _componentsUiTitledGroup = require('components/ui/titled-group');

var _componentsUiTitledGroup2 = _interopRequireDefault(_componentsUiTitledGroup);

var _group = require('./group');

var _group2 = _interopRequireDefault(_group);

var ModuleInspectorPropertyTypeMultiGroup = _react2['default'].createClass({
  displayName: 'ModuleInspectorPropertyTypeMultiGroup',

  render: function render() {
    var props = this.props;

    var groupNodes = [];

    var values = props.value || [];
    values = values.filter(function (v) {
      return v;
    });

    for (var i = 0; i < values.length + 1; i += 1) {
      var value = values[i];

      var groupNode = _react2['default'].createElement(_group2['default'], _extends({
        key: i
      }, props, {
        value: value,
        ref: 'group-' + i,
        componentTypeMultiGroup: ModuleInspectorPropertyTypeMultiGroup,
        onChange: this._onChange.bind(null, i),
        onPerformAction: this._onPerformAction }));

      groupNodes.push(groupNode);
    }

    return _react2['default'].createElement(
      _componentsUiTitledGroup2['default'],
      {
        className: 'multi-group-component',
        title: _storesModuleInspector2['default'].translate(props.groupName + '_' + props.name) },
      groupNodes
    );
  },

  _onChange: function _onChange(groupIndex, originalGroupValue, newGroupValue) {
    var props = this.props;

    var value = (props.value || []).map(function (item) {
      return item;
    });

    value[groupIndex] = newGroupValue;

    if (props.onChange) {
      /* Send original value and new value */
      props.onChange(props.value, value);
    }
  },

  _onPerformAction: function _onPerformAction(buttonName) {
    var props = this.props;

    if (props.onPerformAction) {
      props.onPerformAction(buttonName);
    }
  }
});

module.exports = ModuleInspectorPropertyTypeMultiGroup;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/playground/module/inspector/type/multi-group.js
 **/